import React from "react";
import styled from "styled-components";
import {
  GlossyThemeProvider,
  Radius,
  background,
  cover,
  form,
  transparentize,
} from "@glossy";
import { Fieldset } from "@ui-kit/form";
import { Label } from "@ui-kit/form";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import Illustration from "@radarly/shared/cards/edition/illustration";
interface SharedPanelsCardEditionSidebarProps {
  card: Card;
  openPanel: () => void;
}

const Viz = styled.div`
  height: 82px;
  background-color: ${background};
  border-radius: ${Radius.Medium};
  padding: 12px;
  cursor: pointer;
  position: relative;
  :hover:after {
    content: "";
    ${cover()};
    border-radius: inherit;
    background-color: ${(props) => transparentize(0.8, form(props, "primary"))};
  }
`;

const SharedPanelsCardEditionSidebar = ({
  card,
  openPanel,
}: SharedPanelsCardEditionSidebarProps) => {
  const locale = useCurrentUserLocale();
  return (
    <Fieldset>
      <Label>{tr(locale, "CUSTOM_PAGES::EDITOR::CHART_TYPE")}</Label>
      <GlossyThemeProvider name="tile">
        <Viz onClick={openPanel}>
          <Illustration dataviz={card.dataviz} fragments={card.fragments} />
        </Viz>
      </GlossyThemeProvider>
    </Fieldset>
  );
};

export default SharedPanelsCardEditionSidebar;
